import { PaymentData, ApplePayConfiguration } from '@adyen/adyen-web';

import { EPaymentProvider, PaymentMethod } from '../../../../../../contracts';

export const APPLE_PAY_CONFIG: ApplePayConfiguration = {
  isExpress: true,
  showPayButton: true,
  requiredBillingContactFields: ['email'],
  requiredShippingContactFields: ['email'],
};

export interface ApplePayPaymentDetailsRef {
  email: string;
  paymentMethodDetails: ApplePayJS.ApplePayPaymentMethod;
}

export function createAdyenApplePayFinalizeRequestBody(
  AdyenPaymentMethod: PaymentData,
  applePaymentDetails: ApplePayPaymentDetailsRef,
  ACPaymentMethod: PaymentMethod
): any {
  return {
    paymentProvider: EPaymentProvider.adyen,
    receipt_email: applePaymentDetails.email,
    paymentMethodDisplayName: ACPaymentMethod?.paymentMethodDisplayName!,
    paymentMethodId: ACPaymentMethod?.id!,
    params: {
      paymentMethod: AdyenPaymentMethod.paymentMethod,
      paymentMethodDetails: applePaymentDetails.paymentMethodDetails,
    },
  };
}
